import i18next from 'i18next';

export const formatPrice = (price) => {
    return (
        price
            ?.toFixed(2)

            .replace('.', ',')
            .replace(/\B(?=(\d{3})+(?!\d))/g, '.') ?? '-'
    );
};

export const getTopBottomCoordinates = (position, min, max) => {
    const coordinateFactory = {
        top: () => formatPrice(Math.max(min, max)),
        bottom: () => formatPrice(Math.min(min, max))
    };

    return coordinateFactory[position] ? coordinateFactory[position]() : null;
};

export const getLevelTitle = (priceTargetLevel) => {
    if (priceTargetLevel === 1) {
        return i18next.t('price_target');
    } else {
        return i18next.t('trading_area');
    }
};

export const getStateDescription = (priceTargetState) => {
    switch (priceTargetState) {
        case 'In der Zielzone':
            return i18next.t('in_the_range_description');
        case 'Auf Zielzone zulaufend':
            return i18next.t('active_description');
        case 'Ziel erreicht (Beendet)':
        case 'Erfolgreich':
            return i18next.t('finished_description');
        case 'Alternativszenario':
        case 'Alternative':
            return i18next.t('alternative_description');
        case 'Verworfen':
            return i18next.t('discarded_description');
        case 'Gescheitert':
            return i18next.t('failed_description');
        default:
            return priceTargetState;
    }
};

export const insertStateClasses = (state) => {
    const map = {
        'Ziel erreicht (Beendet)': 'bg-green/10 text-green',
        Verworfen: 'bg-red/10 text-red',
        'In der Zielzone': 'bg-blue/10 text-blue',
        'Auf Zielzone zulaufend': 'bg-yellow-500/10 text-yellow-700',
        Alternativszenario: 'bg-gray-600/10 text-gray-800',
        Gescheitert: 'bg-red/10 text-red'
    };

    return map[state] || '';
};

export const getLevelDescription = (priceTargetlevel) => {
    if (priceTargetlevel === 1) {
        return i18next.t('price_target_description');
    } else {
        return i18next.t('trading_area_description');
    }
};

export const lastMarketAnalysis = (id) => {
    if (id) {
        return `/dashboard/markets-analysis/${id}`;
    }

    return '/dashboard';
};
